<div attr.id="{{sliderId}}" style="z-index: 99 !important;" class="right-sidebar p-t-66 scrollbar scrollableHz custom-scroll">
  <div class="m-b-20">
    <section>
      <a class="pt-0" style="position: absolute; right: 15px;" (click)="closeNav($event)">
        <span class="material-icons slidier-close">clear</span>
      </a>
      <h2 class="mdc-typography--headline5 mb-0 mt-1" style="padding-left: 30px">{{sliderHeader}}</h2>
    </section>
    <div *ngIf="sliderDescription != undefined">
      <p class="mdc-typography--body2">
        <span style="padding-left: 30px" class="sliderDescription">{{sliderDescription}}</span>
      </p>
    </div>
  </div>
  <div class="col-sm-12 m-b-10" >
    <div class="row-fluid" >
      <ng-content></ng-content>
    </div>
  </div>
</div>

